import { ErrorInfo } from 'react';

type EventHandler = (data?: any) => void;

export interface ErrorEventData {
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export const ERROR_EVENTS = {
  ERROR_OCCURRED: 'error:occurred',
  ERROR_DISMISSED: 'error:dismissed',
};

type ErrorEvent = (typeof ERROR_EVENTS)[keyof typeof ERROR_EVENTS];

class ErrorEventEmitter {
  private static instance: ErrorEventEmitter;
  private events: Map<ErrorEvent, EventHandler[]>;

  private constructor() {
    this.events = new Map();
  }

  public static getInstance(): ErrorEventEmitter {
    if (!ErrorEventEmitter.instance) {
      ErrorEventEmitter.instance = new ErrorEventEmitter();
    }
    return ErrorEventEmitter.instance;
  }

  public on(event: ErrorEvent, handler: EventHandler): () => void {
    if (!this.events.has(event)) {
      this.events.set(event, []);
    }

    const handlers = this.events.get(event)!;
    handlers.push(handler);

    return () => {
      const index = handlers.indexOf(handler);
      if (index > -1) {
        handlers.splice(index, 1);
      }
    };
  }

  public emit(event: ErrorEvent, data?: any): void {
    if (this.events.has(event)) {
      this.events.get(event)!.forEach((handler) => handler(data));
    }
  }

  public removeAllListeners(event?: ErrorEvent): void {
    if (event) {
      this.events.delete(event);
    } else {
      this.events.clear();
    }
  }
}

export default ErrorEventEmitter.getInstance();
